export enum RouteTravelMode {
  DRIVE = "DRIVE",
  WALK = "WALK",
}
